import Marchio from '../components/Marchio'
import { t } from '../i18n/lingua'

/**
 * La pagina che CENSO Monitor apre sullo schermo mentre aspetta
 * l'accoppiamento: il marchio, il codice a sei cifre, due righe di
 * istruzioni. Pubblica (nessuna sessione, nessun dato): il codice lo porta
 * l'indirizzo, e vale solo per chi lo scrive nella console entro quindici
 * minuti.
 */
export default function MonitorAttesa() {
  const q = new URLSearchParams(window.location.search)
  const codice = (q.get('code') ?? '').replace(/\D/g, '')
  const host = q.get('host') ?? ''
  const bello = codice.length === 6 ? `${codice.slice(0, 3)} ${codice.slice(3)}` : codice
  return (
    <div className="sinottico esin">
      <header className="esin__testa">
        <div className="esin__brand" aria-label="CENSO · DiscoveryGuard">
          <Marchio size={34} />
          <span className="esin__brand-nome" aria-hidden="true">{'CENSO'}<small>{'DiscoveryGuard'}</small></span>
        </div>
      </header>
      <div className="esin__avviso mattesa">
        <h2>{t('Questo schermo aspetta di essere accoppiato')}</h2>
        {codice ? (
          <>
            <p className="mattesa__codice" aria-label={t('Codice di accoppiamento')}>{bello}</p>
            <p>{t('In CENSO, Eagle → Sinottici pubblicati → «Accoppia un monitor»: scrivi questo codice, dai un nome al monitor e scegli il cruscotto. Il codice vale quindici minuti.')}</p>
          </>
        ) : (
          <p>{t('CENSO Monitor sta chiedendo un codice al Control Plane: se non compare, controlla l’indirizzo del server e la rete.')}</p>
        )}
        {host && <p className="muted">{t('Macchina: {host}', { host })}</p>}
      </div>
    </div>
  )
}
